module.exports = __webpack_public_path__ + "static/media/FTM-logo.8f14871e.png";